export const HOME_CONTENT_ID = '7oVdebBAoRhsycfIyWDUbD';
export const IAM_CONTENT_ID = '6bKJ0yaVXDRBqBy1sjQFt5';
export const VB_CONTENT_ID = '4xuU6zkIoUmQGANOE8UKR6';
export const EDR_CONTENT_ID = '3Q8dPil7oujx6Fp9v1nrv';
export const NAV_CONTENT_ID = '6n1ObLfVF8YjhF5i5D3jbM';
export const FAQ_CONTENT_ID = '5rRD2C7TbkOjNUBmdqRrDF';
export const MAINTENANCE_CONTENT_ID = '6qdx7MVWS4mjbioRmMlHNc';
